module.exports = __webpack_public_path__ + "img/bell_4.afc5d019.jpg";